import { Capacitor } from '@capacitor/core';
import {
  SENTRY_IGNORE_ERROR_PATTERNS,
  createSentryBeforeSend,
} from './sentryEventFilter';
import { flushPreSentryErrorBuffer } from './preSentryErrorBuffer';

/** Initialise Sentry après idle pour ne pas alourdir le chemin critique main.js. */
export function scheduleSentryInit(): void {
  const dsn = process.env.REACT_APP_SENTRY_DSN?.trim();
  if (!dsn) return;

  const run = () => {
    void import('@sentry/react').then((Sentry) => {
      const isNativeRuntime = Capacitor.isNativePlatform();
      Sentry.init({
        dsn,
        integrations: [
          Sentry.browserTracingIntegration(),
          Sentry.replayIntegration(),
        ],
        tracesSampleRate: isNativeRuntime ? 0.1 : 1.0,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        denyUrls: [/iabjs:\/\//, /extensions\//i, /^chrome:\/\//i],
        ignoreErrors: SENTRY_IGNORE_ERROR_PATTERNS,
        beforeSend: createSentryBeforeSend((event) => {
          const frames = event.exception?.values?.[0]?.stacktrace?.frames ?? [];
          if (frames.some((frame) => frame.filename?.includes('autofill_contact_enhanced'))) {
            return null;
          }
          return event;
        }),
      });
      flushPreSentryErrorBuffer((error) => {
        Sentry.captureException(error);
      });
    });
  };

  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(run, { timeout: 4000 });
  } else {
    window.setTimeout(run, 1500);
  }
}
